import React, { useState } from "react";
import {
  Typography,
  Box,
  Grid,
  FormControlLabel,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Info } from "@mui/icons-material";
import CreateImage from "../AddContent/ContentForm/CreateImage";
import Button from "../../common/Button";
import CustomSwitch from "../../common/Swicth";
import { useOrganisation } from "../../../hooks/useOrganisation";

const LogoAndFaviconStep = ({
  logo,
  handleLogoUpload,
  favicon,
  handleFaviconUpload,
  useLogo,
  setUseLogo,
  handleBack,
  handleNext,
  update,
}) => {
  const { primaryColor } = useOrganisation();

  return (
    <Box>
      {/* Logo Section */}
      <Box sx={{ mb: 5 }}>
        <Typography variant="h6">
          Upload your logo .
          <Tooltip
            title={`Upload an svg OR png logo for a better quality Ideal:
            Width: 300-400 pixel
            Maximum Height: 200 pixels
            Aspect Ratio: Keep between 1:1 to 3:1 (width to height)`}
          >
            <IconButton>
              <Info />
            </IconButton>
          </Tooltip>
          <Typography variant="body1">
            Ensure logo colour contrasts with primary colour choice.
          </Typography>
        </Typography>
        <Grid item>
          <CreateImage
            image={logo}
            setImage={handleLogoUpload}
            isLogo={true}
            update={update}
          />
        </Grid>
      </Box>

      <Divider sx={{ my: 3 }} />

      {/* Favicon Section */}
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h6">
          Upload Your Favicon
          <Tooltip
            title="Please upload a square image with dimensions of 96x96px for optimal display."
            arrow
            placement="right"
          >
            <IconButton size="small" sx={{ ml: 1 }}>
              <HelpOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          A favicon appears in browser tabs and bookmarks, helping users
          identify your site.
        </Typography>

        <FormControlLabel
          control={
            <CustomSwitch
              checked={useLogo}
              onChange={(e) => setUseLogo(e.target.checked)}
            />
          }
          label="Use logo as favicon"
          sx={{ mb: 2 }}
        />

        {!useLogo && (
          <Box sx={{ mb: 3 }}>
            <CreateImage
              image={favicon}
              setImage={handleFaviconUpload}
              isLogo={false}
              update={update}
              isFavicon={true}
            />
          </Box>
        )}

        {useLogo ? (
          <Box sx={{ mt: 2, mb: 3 }}>
            <Typography variant="body2" color="text.secondary">
              Your logo will be used as the favicon. If you didn't upload a logo
              the Komz favicon will be displayed
            </Typography>
          </Box>
        ) : (
          <Box sx={{ mt: 2, mb: 3 }}>
            <Typography variant="body2" color="text.secondary">
              The favicon is shown in browser tabs, bookmarks, and mobile home
              screens.
            </Typography>
          </Box>
        )}
      </Box>

      {/* Navigation Buttons */}
      <Box sx={{ display: "flex", justifyContent: "end", mt: 4 }}>
        <Button onClick={handleBack} text="Back" backgroundColor="white" />
        <Button onClick={handleNext} text="Next" />
      </Box>
    </Box>
  );
};

export default LogoAndFaviconStep;
